<template>
  <div class="page-listings">
    <div id="pag" style="position: absolute; top: 0;"></div>
    <banner-1 title="FreeSpan Opportunity Registration" desc="Please fill out this form to submit a new Opportunity Registration. The requested information is imperative to project strategy and will help Spacesaver better support you."/>

    <section id="ScrollTarget" class="py-5 bs-shadow mobile-top">
      
      <div data-v-5a90ec03 class="container">

        <!--
        {{productTypesSelected.join(', ')}}
        -->
        

       <!--  
        <h1 class="lh1">Interterritorial Projects</h1>
        -->
        
  
        
    

        <transition
          enter-active-class="animated fadeIn"
          leave-active-class="animated fadeOut"
          :duration="500"
          mode="out-in"
          appear
        >
        <div>
          <div v-if="step == 1" class="step1" key="step1">
            <div class="listing">
          
              <h5>
                <span class="teal"> Account Information</span>
              </h5>
              <hr />
              <div class="row">
                <div class="col-xs-12 col-md-6 col-12">

                  <div class="form-group">
                    <label for="exampleInputEmail1"
                      >* Area Contractor <small v-if="check1 && !acFilter" class="orange">This field is required.</small></label>
                    
                    <select
                  v-if="loading && acFilter == null"
                  disabled
                  class="form-control"
                  id="exampleFormControlSelect1"
                  style="padding: 0.375rem 0.75rem!important;"
                  v-model="acFilter"
                >
                  <option :value="null" selected class="all-contractors">
                    Area Contractor
                  </option>
                </select>

                <select
                  v-else
                  class="form-control"
                  id="exampleFormControlSelect1"
                  style="padding: 0.375rem 0.75rem!important;"
                  v-model="acFilter"
                  v-on:change="getTerritories()"
                  :disabled="loading"
                >
                  <option :value="null" selected class="all-contractors">
                    Area Contractor
                  </option>
                  <option
                    v-for="ac in acs"
                    @click="setACFilterName(ac.acName)"
                    :key="ac.acid"
                    :value="ac"
                  >
                    {{ " " + ac.acName + " (" + ac.acid + ")" }}
                  </option>
                </select>
                  </div>

                  <div class="form-group">
                    <label for="exampleInputEmail1"
                      >* Sales Rep  <small v-if="check1 && !repFilter" class="orange">This field is required.</small></label>
                    
                    <select
                  class="form-control"
                  id="exampleFormControlSelect1"
                  style="padding: 0.375rem 0.75rem!important;"
                  v-model="repFilter"
                >
                  <option :value="null" selected class="all-contractors">
                    Sales Rep
                  </option>
                   <option
                    v-for="rep in filteredReps"
                    :key="rep.fullName"
                    :value="rep.fullName"
                  >
                    {{ rep.fullName }}
                  </option>
                </select>
                </div>



             

           
            
                
           
               

              
          
        
         
                </div>
                <div class="col-xs-12 col-md-6 col-12">
                          <div class="form-group">
                  <label for="exampleFormControlSelect1">* Project Market <small v-if="check1 && !MarketSelection" class="orange">This field is required.</small></label>
                  <select
                    v-model="MarketSelection"
                    class="form-control"
                    id="exampleFormControlSelect1"
                    style="padding: 0.375rem 0.75rem!important;"
                  >
                    <option
                      disabled
                      v-bind:value="null"
                      class="all-contractors"
                    >
                      Select a market
                    </option>

                    <option value="Agriculture">Agriculture</option>
                    <option value="Business">Business</option>
                    <option value="Education">Education</option>
                    <option value="Education K-12">Education K-12</option>
                    <option value="Government">Government</option>
                    <option value="Healthcare">Healthcare</option>
                    <option value="Library">Library</option>
                    <option value="Military">Military</option>
                    <option value="Museum">Museum</option>
                    <option value="Public Safety">Public Safety</option>             
                    <option value="Unknown">Unknown</option>
                  </select>
                </div>
                       <div class="form-group">
                    <label for="exampleInputEmail1"
                      >* Opportunity Name / Department <small v-if="check1 && !projectName" class="orange">This field is required.</small></label
                    >
                    <input
                      type="text"
                      class="form-control"
                      aria-describedby="Project Name"
                      placeholder="Department where install is taking place, product(s) being installed"
                      v-model="projectName"
                    />
                  </div>

         
                  
       

                            
                </div>
              </div>
                  <h5>
                <span class="teal"> Customer Information</span>
              </h5>
              <hr />
           
  <div class="row" style="padding-top: 10px;">
                <div class="col-xs-12 col-md-6 col-12">
                <div class="form-group">
                  <label for="exampleInputEmail1">* End User/Customer Name <small v-if="check1 && !AccountName.length" class="orange">This field is required.</small></label>
                  <input
                    type="text"
                    class="form-control"
                    aria-describedby="Account Name"
                    placeholder="Legal Company Name"
                    v-model="AccountName"
                  />
                </div> 
                <div class="form-group">
                    <label for="exampleFormControlTextarea1">* End User/Customer Street Address <small v-if="check2 && !projectAddress.length" class="orange">This field is required.</small></label>
                    <textarea
                      class="form-control"
                      id="exampleFormControlTextarea1"
                      rows="1"
                      placeholder="Enter Street Address..."
                      v-model="projectAddress"
                      required
                    ></textarea>
                  </div>

                  <div class="form-group">
                    <label for="exampleInputEmail1">* End User/Customer City <small v-if="check2 && !projectCity.length" class="orange">This field is required.</small></label>
                    <input
                      type="text"
                      class="form-control"
                      aria-describedby="City"
                      placeholder="Enter City"
                      v-model="projectCity"
                      required
                    />
                  </div>
                   <div class="form-group">
                    <label for="exampleInputEmail1"
                      >* End User/Customer State <small v-if="check2 && !projectState.length" class="orange">This field is required.</small>
                      </label
                    >
                    <input
                      type="text"
                      class="form-control"
                      aria-describedby="State"
                      placeholder="Enter State"
                      :maxlength="statemax"
                      required
                      :value="projectState.toUpperCase()"
                      @input="projectState = $event.target.value.toUpperCase()"
                    />
                  </div>
                
                  </div>
                    <div class="col-xs-12 col-md-6 col-12">
                        <div class="form-group">
                    <label for="exampleInputEmail1">* End User/Customer Zip Code <small v-if="check2 && !projectZip.length" class="orange">This field is required.</small></label>
                    <input
                      type="text"
                      class="form-control"
                      aria-describedby="Zip Code"
                      placeholder="Enter Zip Code"
                      v-model="projectZip"
                      required
                    />
                  </div>
                             <div class="form-group">
                    <label for="exampleInputEmail1"
                      >* Contact Name <small v-if="check2 && !contactName.length" class="orange">This field is required.</small><small v-if="check2 && (!this.checkFirst ||
                      !this.checkLast)" class="orange"> Please enter a first and last name</small></label
                    >
                   
                    <input
                      type="text"
                      class="form-control"
                      aria-describedby="Project Name"
                      placeholder="Enter Project Contact First and Last Name"
                      v-model="contactName"
                    />
                  </div>

                  <div class="form-group">
                    <label for="exampleInputEmail1">* Contact Phone</label>
                    <input
                      type="text"
                      class="form-control"
                      aria-describedby="Phone"
                      placeholder="Enter Contact Phone"
                      v-model="contactPhone"
                      required
                    />
                  </div>
                  <div class="form-group">
                    <label for="exampleInputEmail1">* Contact Email</label>
                    <input
                      type="text"
                      class="form-control"
                      aria-describedby="Email"
                      placeholder="Enter Contact Email"
                      v-model="contactEmail"
                      required
                    />
                  </div>
                  </div>
                  </div>

         <h5>
                <span class="teal"> Architect Information</span>
              </h5>
   <hr />
  <div class="row" style="padding-top: 10px;">
      <div class="col-xs-12 col-md-6 col-12">
<div class="form-group" style="margin-bottom: 15px;">
  <label style="margin-bottom: 20px; display: block;">
    Are you working with an architect? <small v-if="check1 && workWithArchitect === null" class="orange">This field is required.</small>
  </label>

  <div class="custom-radio-group">
     <label class="custom-radio">
      <input 
        type="radio" 
        name="workWithArchitect" 
        id="architect-no" 
        value="false" 
        v-model="workWithArchitect"
      >
      <span class="radio-dot"></span>
      No
    </label>
    <label class="custom-radio">
      <input 
        type="radio" 
        name="workWithArchitect" 
        id="architect-yes" 
        value="true" 
        v-model="workWithArchitect"
      >
      <span class="radio-dot"></span>
      Yes
    </label>

   
  </div>
</div>
    <span v-if="workWithArchitect == 'true'">

      
        
      
      
       

      
     <div class="form-group">
                  <label for="exampleInputEmail1">Architecture Firm <small v-if="check1 && !AccountName.length" class="orange">This field is required.</small></label>
                  <input
                    type="text"
                    class="form-control"
                    aria-describedby="Account Name"
                    placeholder="Legal Company Name"
                    v-model="ArchitectureFirm"
                  />
                </div> 
                <div class="form-group">
                    <label for="exampleFormControlTextarea1">Architecture Firm Street Address <small v-if="check2 && !projectAddress.length" class="orange">This field is required.</small></label>
                    <textarea
                      class="form-control"
                      id="exampleFormControlTextarea1"
                      rows="1"
                      placeholder="Enter Street Address..."
                      v-model="ArchFirmStreetAddress"
                      required
                    ></textarea>
                  </div>

                  <div class="form-group">
                    <label for="exampleInputEmail1">Architecture Firm City <small v-if="check2 && !projectCity.length" class="orange">This field is required.</small></label>
                    <input
                      type="text"
                      class="form-control"
                      aria-describedby="City"
                      placeholder="Enter City"
                      v-model="ArchFirmCity"
                      required
                    />
                  </div>
      </span>
               
      </div>
      <div class="col-xs-12 col-md-6 col-12">
        <span v-if="workWithArchitect == 'true'">
            <div class="form-group architect-question">
                    <label for="exampleInputEmail1"
                      >Architecture Firm State <small v-if="check2 && !projectState.length" class="orange">This field is required.</small>
                      </label
                    >
                    <input
                      type="text"
                      class="form-control"
                      aria-describedby="State"
                      placeholder="Enter State"
                      :maxlength="statemax"
                      required
                      v-model="ArchFirmState"
                    />
                  </div>

                                         <div class="form-group">
                    <label for="exampleInputEmail1"
                      >Architect Name <small v-if="check2 && !contactName.length" class="orange">This field is required.</small><small v-if="check2 && (!this.checkFirst ||
                      !this.checkLast)" class="orange"> Please enter a first and last name</small></label
                    >
                   
                    <input
                      type="text"
                      class="form-control"
                      aria-describedby="Project Name"
                      placeholder="Enter Architect First and Last Name"
                      v-model="ArchitectName"
                    />
                  </div>

                  <div class="form-group">
                    <label for="exampleInputEmail1">Architect Phone</label>
                    <input
                      type="text"
                      class="form-control"
                      aria-describedby="Phone"
                      placeholder="Enter Architect Phone"
                      v-model="ArchitectPhone"
                      required
                    />
                  </div>
                  <div class="form-group">
                    <label for="exampleInputEmail1">Architect Email</label>
                    <input
                      type="text"
                      class="form-control"
                      aria-describedby="Email"
                      placeholder="Enter Architect Email"
                      v-model="ArchitectEmail"
                      required
                    />
                  </div>
                  </span>
      </div>
  </div>


                   <div class="row">
              <div class="col col-12">
                <div
                  class="
                    nav-btns
                    listing-header
                    d-flex
                    align-items-center
                    mt10
                    mb10
                    rounded
                    b-shadow
                  "
                >



          
                         <button
                      disabled
                      v-if="this.submitted"
                      class="mlauto"
                    >
                      Submitted
                      <i class="material-icons">keyboard_arrow_right</i>
                    </button>


                    <button
                      v-else
                      @click="validateAndShow"
                      class="mlauto"
                    >
                      Submit Opportunity
                      <i class="material-icons">keyboard_arrow_right</i>
                    </button>
    
                </div>
              </div>
            </div>
            </div>
          </div>

            <div v-if="step == 2" class="step1" key="step1">
            <div class="listing">    
             
              <div class="success-header">
                <img src="@/assets/img/success.svg"/>
                <h1>Awesome!</h1>
              </div>
              <div class="success-body">
                 <h4 style="color: #5a6877">
                The opportunity has been submitted!
                </h4>
              </div>
             
   
  
            </div>
          </div>
           <div v-if="step == 3" class="step1" key="step1">
            <div class="listing">    
             
              <div class="failure-header">
                <img src="@/assets/img/sad.svg"/>
                <h1>Sorry</h1>
              </div>
              <div class="failure-body">
                 <h4 style="color: #5a6877">
                There was an issue submitting your project.
                </h4>
                <p className="text-base">please reach out to <a className="text-teal-lightest dark:text-teal-lightest" href="mailto:hbare@spacesaver.com">hbare@spacesaver.com</a></p>
                <p className="text-base">or give us a call at <a className="text-teal-lightest dark:text-teal-lightest" href="tel:9205630611">920.563.0611</a></p>
                <p className="text-base">and we will get it fixed as soon as possible.</p>
              </div>
             
   
  
            </div>
          </div>
          </div>
        </transition>
      </div>
    </section>
  </div>
</template>

<script>
import axios from "axios";
import { AtomSpinner } from "epic-spinners";
// import Avatar from "vue-avatar";
// import Datepicker from "vuejs-datepicker";
import VueDatePicker from '@vuepic/vue-datepicker';
import Multiselect from "vue-multiselect";
import { HollowDotsSpinner } from "epic-spinners";
import Banner1 from "../components/Banners/banner1.vue";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import "vue-multiselect/dist/vue-multiselect.min.css";
// import "animate.css";




const auth = {
  headers: {
    Authorization: "Bearer " + localStorage.getItem("SSCUSER"),
  },
};

export default {
  name: "OpportunityRegistration",
  components: {
    AtomSpinner,
    // Avatar,
    // Datepicker,
    VueDatePicker,
    Multiselect,
    HollowDotsSpinner,
    Banner1,
    vSelect
  },
  data() {
    return {
      ordermanageapi: import.meta.env.VITE_APP_ORDER_MANAGE_API,
      server: import.meta.env.VITE_APP_SERVER_URL,
      // server: 'http://localhost:5002',
      backend: import.meta.env.VUE_APP_SERVER_URL,
      loading: true,
      projectName: "",
      customerName: "",
      MarketSelection:null,
      acFilter: null,
      repFilter: null,
      AccountName: "",
      projectAddress: "",
      projectCity: "",
      projectState: "",
      projectZip: "",
      bidDate:"",
      orderDate: "",
      shipDate: "",
      productTypes: [],
      statemax: 2,
      contactName: "", 
      contactPhone: "",
      contactEmail: "",
      ArchitectureFirm: "",
      ArchFirmStreetAddress: "",
      ArchFirmCity: "",
      ArchFirmState: "",
      ArchitectName: "",
      ArchitectPhone: "",
      ArchitectEmail: "",
      projectReason: "",
      step: 1,    
      userEmail: "",
      jobName: "",
      jobDesc: "",
      jobMarket: null,         
      leadSalesPerson: null,
      acList: null,
      State: "",
      County: "",
      AC: "",   
      acid: null,
      check1: false,
      submitted: false,
      salespeople: null,  
      workWithArchitect: false,     
    };
  },
  methods: {
    GetCompanyID() {
        let number = this.$store.state.user.ACId[0];
        this.acFilter = number;
    },
    removeTag(tagToBeRemove) {
      this.selected = this.selected.filter((tag) => tag.name !== tagToBeRemove.name);
      Bus.$emit('update:tags', this.selected);
    },

    async firstLoad() {
      this.loading = true;

      try {
        // 1. Active customer list
        const acResponse = await axios.get(
          `${this.ordermanageapi}/aclist?active=true`,
          auth
        );
        this.acs = acResponse.data;
        // this.GetCompanyID();

        // 2. Salespeople
        const spResponse = await axios.get(
          `${this.ordermanageapi}/salespeople`,
          auth
        );
        this.salespeople = spResponse.data.salesPeople;

        // 3. Product types
        const ptResponse = await axios.get(
          `${this.ordermanageapi}/options?type=ptypes`,
          auth
        );
        this.productTypes = ptResponse.data.productTypes;

        // 4. AC territories
        /*
        const territoryResponse = await axios.get(
          `${this.server}/api/v1/ac-territories`,
          auth
        );

        if (territoryResponse.status === 401) {
          console.warn("Not allowed to access ac-territories");
          // or: this.$router.push("/");  ← decide what you want
        } else {
          this.acList = territoryResponse.data.aCDistributors;
        }
        */

      } catch (error) {
        console.error("firstLoad failed:", error);

        if (error.response?.status === 401) {
          this.$router.push("/");
          return; // stop further execution
        }

    
      } finally {
        this.loading = false;
      }
    },
    submitProject(){
      let axiosConfig = {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: "Bearer " + localStorage.getItem("SSCUSER"),
        },
      };

      const fullName = this.contactName.split(' ');
 
      let postProjectData = {
          AreaContractorID: isNaN(Number(this.acFilter.acid)) ? null : Number(this.acFilter.acid),
          AreaContractorName: this.acFilter.acName,
          SalesRep: this.repFilter,
          ProjectMarket: this.MarketSelection,
          OpportunityNameDepartment: this.projectName,
          EndUserCustomerName: this.AccountName,
          EndUserStreetAddress: this.projectAddress,
          EndUserCity: this.projectCity,
          EndUserState: this.projectState,
          EndUserZipCode: this.projectZip,
          ContactName: this.contactName,
          ContactPhone: this.contactPhone,
          ContactEmail: this.contactEmail,
          ArchitectureFirm: this.ArchitectureFirm,
          ArchFirmStreetAddress: this.ArchFirmStreetAddress,
          ArchFirmCity: this.ArchFirmCity,
          ArchFirmState: this.ArchFirmState,
          ArchitectName: this.ArchitectName,
          ArchitectPhone: this.ArchitectPhone,
          ArchitectEmail: this.ArchitectEmail,
      };

      this.submitted = true;

      axios.post(`${this.server}/api/v1/freespan-opportunities`, postProjectData, axiosConfig).then(
        (response) => {
          console.log(response);
          if (response.data && response.data.message == "Opportunity created successfully") {
            this.$toast.success("Successfully created your opportunity submission!");
            this.step = this.step + 1;
            const el = document.getElementById("pag");
            el.scrollIntoView({ behavior: "smooth" });
          } else {
            // this.$router.push(`/interterritorial/${returnedID}`);
            this.$toast.error(
              "Sorry, there was an error submitting your opportunity"
            );
            this.step = this.step + 2;
            const el = document.getElementById("pag");
            el.scrollIntoView({ behavior: "smooth" });
          }
          
        },
        (error) => {
          console.log(error);
        }
      );

    },

    removeDollarSign: function () {
      if (this.SSCNetValue != null) {
        //console.log("removing");
        this.SSCNetValue = this.SSCNetValue.replace("$", "");
      }
    },

    formatDate(date) {
      var d = new Date(date),
        month = "" + (d.getMonth() + 1),
        day = "" + d.getDate(),
        year = d.getFullYear();

      if (month.length < 2) month = "0" + month;
      if (day.length < 2) day = "0" + day;

      return [year, month, day].join("-");
    },

    setPage: function (idx) {
      document.activeElement.blur();
      if (idx <= 0 || idx > this.totalPage) {
        return;
      }
      document
        .getElementById("ScrollTarget")
        .scrollIntoView({ behavior: "smooth" });
      this.step = idx;
    },
    validate() {
      const errors = [];

      if (this.acFilter === '' || this.acFilter == null || isNaN(Number(this.acFilter.acid))) {
        errors.push("Area Contractor is required.");
      }

      if(!this.repFilter){
        errors.push("Sales Rep is required.");
      }

      if(!this.MarketSelection){
        errors.push("Market is required.");
      }

      if(!this.projectName){
        errors.push("Opportunity Name / Department is required")
      }
      // ───────────────────────────────────────────────
      // Customer information
      // ───────────────────────────────────────────────
      if (!String(this.AccountName ?? '').trim()) {
        errors.push("End User/Customer Name is required.");
      }

      if (!String(this.projectAddress ?? '').trim()) {
        errors.push("End User/Customer Street Address is required.");
      }

      if (!String(this.projectCity ?? '').trim()) {
        errors.push("End User/Customer City is required.");
      }

      if (!String(this.projectState ?? '').trim()) {
        errors.push("End User/Customer State is required.");
      }

      if (!String(this.projectZip ?? '').trim()) {
        errors.push("End User/Customer Zip Code is required.");
      }

      /* COntact */

      if (!String(this.contactName ?? '').trim()) {
        errors.push("Contact Name is required.");
      }
      if (!String(this.contactPhone ?? '').trim()) {
        errors.push("Contact Phone is required.");
      }
      if (!String(this.contactEmail ?? '').trim()) {
        errors.push("Contact Email is required.");
      }

      console.log(errors)

      return {
        isValid: errors.length === 0,
        errors,
      };
    },
    validateAndShow() {
      const { isValid, errors } = this.validate();

      if (isValid) {
        this.submitProject()
        // alert("it's good!")
        return;
      }
      // Show up to ~5 individual toasts, then a summary
      if (errors.length <= 5) {
        errors.forEach((err) => {
          this.$toast.error(err);
        });
      } else {
        errors.slice(0, 3).forEach(err => this.$toast.error(err));
      }
    },
  },
  computed: {
    filteredReps() {
      if (!this.acFilter) {
        return this.salespeople
      }

      return this.salespeople.filter(user => 
        user.acid === Number(this.acFilter.acid)
      )
    },
    activeNav() {
      return this.$store.state.activePage;
    },
    colorGetter() {
      return this.$store.state.colors;
    },
     checkFirst: function(){
       if(this.contactName.length){
         let fullName = this.contactName.split(' ');
         return fullName[0]
       } else {
         return '';
       }
    },

    checkLast: function(){
       if(this.contactName.length){
         let fullName = this.contactName.split(' ');
         return fullName[1]
       } else {
         return '';
       }
    },



    companyID() {
      let number = this.$store.state.user.ACId[0];
      this.acid = number;
    },
    states() {
      return new Set(this.acList.map((x) => x.State).sort());
    },
  },
  created() {
    this.$store.commit("showNavigation");
    // console.log(this.$route.path);
  },
  mounted() {
    this.firstLoad();
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#pickDate1 input {
  border: 0 !important;
  outline: none !important;
}

.btn-primary:not(:disabled):not(.disabled).active,
.btn-primary:not(:disabled):not(.disabled):active,
.show > .btn-primary.dropdown-toggle {
  color: #fff;
  background-color: #00b4b4;
  border-color: #00b4b4;
}

.leadTime {
  background-color: #fff;
  line-height: 44px;
  padding: 20px;
  margin-bottom: 5px;
  border-top: 0;
}
.top-wrap {
  display: flex;
  align-items: flex-start;
}
.leadTime-bottom {
  align-items: flex-end;
}
.leadTime-header {
  background: #fff;
  color: #575757;
  display: flex !important;
}
.small-lh {
  line-height: 1.4em;
}

.listing {
  overflow: none;
}

.listing {
  background-color: #fff;
  line-height: 1;
  padding: 20px;
  margin-bottom: 5px;
  border-top: 0;
}

.table-responsive {
  display: table;
}
.table-striped tbody tr:nth-of-type(odd) {
  background-color: rgba(0, 0, 0, 0.03) !important;
}
.table-bordered td,
.table-bordered th {
  border: 1px solid #e8e8e8 !important;
}
.badge-success {
  color: #fff;
  background-color: #4d5967;
  background-color: #1eb5b6;
}
.table-striped a {
  color: #00b4b4;
}
.table-striped td,
.table-striped th {
  padding: 5px;
  font-weight: 300 !important;
}
.listing {
  border-radius: 4px;
}
table td {
  line-height: 1;
}
.table-striped th {
  background: #00b4b4;
  background: #4d5967;
  color: #fff;
}
.table-striped {
  min-width: 100%;
  overflow: scroll;
}
.search-btns {
  display: flex;
  margin-top: 10px;
  margin-bottom: 10px;
}
.search-btns button {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  border: none;
  /* background: #519bb2; */
  background: #4d5967;
  color: #fff;
  border-radius: 4px;
  padding: 5px;
  cursor: pointer;
  max-height: 40px;
}
.search-btns .clear {
  margin-left: auto;
}
.search-btns .search {
  margin-left: 5px;
}
.search-btns button span {
  font-size: 20px;
  width: 20px;
  height: 20px;
  color: #fff;
}
.search-btns button:hover {
  background: #586575;
}
.search-btns button:active {
  background: #586575;
}
.search-btns button:disabled {
  opacity: 0.6;
  cursor: unset !important;
}
.search-btns button:disabled:hover {
  background: #4d5967;
}
.search-btns button:disabled:active {
  background: #4d5967;
}

@media all and (min-width: 768px) {
  .dates {
    display: flex;
    color: #757575 !important;
  }
}
.top-search {
  color: #757575;
}
select.form-control:not([size]):not([multiple]) {
  height: auto !important;
  padding: 10px !important;
  color: #757575;
}
.all-contractors {
  color: #757575 !important;
}
.header-divide {
  border-top: 1px solid rgba(255, 255, 255, 0.5);
}
.table-striped td:last-of-type {
  text-align: right;
}
.table-striped th:last-of-type {
  text-align: right;
}
.table-bordered td:first-of-type {
  border-right: none !important;
}
.table-bordered th:first-of-type {
  border-right: none !important;
}
.table-bordered td:last-of-type {
  border-left: none !important;
}
.table-bordered th:last-of-type {
  border-left: none !important;
}
.m50 {
  margin: 50px 0;
}
.nav-btns {
  display: flex;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.25s ease-out;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}
.slide-leave-active,
.slide-enter-active {
  transition: 1s;
}
.slide-enter {
  transform: translate(100%, 0);
}
.slide-leave-to {
  transform: translate(-100%, 0);
}
.listing-header {
  background: #fff;
  color: #575757;
  display: -webkit-box !important;
  display: -ms-flexbox !important;
  display: flex !important;
}
.loader {
  margin: 0 auto 20px;
  width: 100%;
  height: 25px;
  border-radius: 14px;
  border-bottom: 1px solid #fff;
  border-top: 1px solid #999;
  background: #ccc;
  overflow: hidden;
  position: relative;
}

.progress-bar {
  height: inherit;
  width: 0%;
  border-radius: inherit;
  position: relative;
  overflow: hidden;
}

.progress-stripes {
  width: inherit;
  height: inherit;
  font-size: 180px;
  font-weight: bold;
  margin-top: -50px;
  letter-spacing: -14px;
}

.percentage {
  position: absolute;
  top: 0;
  right: 5px;
  font-weight: bold;
  font-size: 16px;
}
/* PURPLE */
.teal .progress-bar {
  background: #00bcbc;
}
.teal .progress-stripes {
  color: #00b4b4;
}
.teal .percentage {
  color: #eee;
}
.first-step {
  width: 20%;
}
.second-step {
  width: 60%;
}
.third-step {
  width: 90%;
}
.fourth-step {
  width: 100%;
}
.fifth-step {
  width: 90%;
}
.teal {
  color: #00b4b4;
}
.lookup-wrapper {
  text-align: center;
}
.lookup-svg {
  width: 300px;
  height: auto;
  max-width: 300px;
  margin-left: auto;
  margin-right: auto;
  margin-right: auto;
  margin: 0 auto;
}
.show-all-btn {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  border: none;
  /* background: #519bb2; */
  background: rgb(124, 124, 129);

  color: #fff;
  border-radius: 4px;
  cursor: pointer;
  margin: 0 auto;
  margin-top: 20px;
}
.show-all-btn:hover {
  background: #4d5967;
}
.custom-control-label:before {
  background-color: #dedede;
}
.custom-checkbox .custom-control-input:checked ~ .custom-control-label::before {
  background-color: #00b4b4 !important;
}
input:focus {
  border-color: #00BCBC;
}
textarea:focus {
  border-color: #00BCBC;
}
</style>
<style>
.style-chooser .vs__selected{
      background-color: #00BCBC!important;
      color: #fff!important;
}
.style-chooser .vs__dropdown-option--highlight{
    background-color: #00BCBC!important;
    color: #fff!important;
}
.style-chooser .vs__selected-options{
  padding: 10px;
}
.style-chooser .vs__dropdown-option .vs__dropdown-option--highlight{
  background-color: #00BCBC!important;
  color: #fff!important;
}
.style-chooser .vs__deselect{
  fill: #fff;
}
.style-chooser .vs__selected{
  border: none;
  font-weight: 300;
  padding: 2px 10px;
}
.style-chooser .vs__dropdown-toggle{
  padding: 0;
}
.style-chooser .vs__search{
  margin: 0;
  padding: 0;
}

element.style {
}
.form-control {
    display: block;
    width: 100%;
    padding: 0.375rem 0.75rem;
    font-size: 1rem;
    line-height: 1.5;
    color: #495057;
    background-color: #fff;
    background-clip: padding-box;
    border: 1px solid #ced4da;
    border-radius: 0.25rem;
    transition: border-color .15s ease-in-out,box-shadow .15s ease-in-out;
}
textarea {
    overflow: auto;
    resize: vertical;
}
button, input, optgroup, select, textarea {
    margin: 0;
    font-family: inherit;
    font-size: inherit;
    line-height: inherit;
}
*, ::after, ::before {
    box-sizing: border-box;
}
user agent stylesheet
textarea {
    box-sizing: border-box;
}
.success-header{
  background: #00b4b4;
  text-align: center;
  color: #fff;
  border-radius: 4px;
  padding: 50px;
}
.success-header img{
    max-width: 200px;
    
}
.failure-header{
  background: #00b4b4;
  text-align: center;
  color: #fff;
  border-radius: 4px;
  padding: 50px;
}
.failure-header img{
    width: 200px;
    
}
.success-body{
  text-align: center;
  padding: 50px;
}
.failure-body{
  text-align: center;
  padding: 50px;
}
.failure-body a{
  color: #00BCBC;
}
.failure-body p {
  margin-bottom: 5px;
}
.orange{
  color:#f16232
}
.custom-radio-group {
  display: flex;
  gap: 1rem; /* space between Yes/No */
}

.custom-radio {
  position: relative;
  display: inline-flex;
  align-items: center;
  cursor: pointer;
  font-size: 1rem;
  color: #495057;
  user-select: none;
}

.custom-radio input[type="radio"] {
  position: absolute;
  opacity: 0;
  width: 0;
  height: 0;
}

/* The outer circle */
.custom-radio .radio-dot {
  position: relative;
  width: 20px;
  height: 20px;
  margin-right: 10px;
  background: #fff;
  border: 2px solid #ced4da; /* default unchecked border */
  border-radius: 50%;
  transition: all 0.2s ease;
}

/* Checked state */
.custom-radio input[type="radio"]:checked + .radio-dot {
  border-color: #00b4b4;
}

/* Inner filled dot when checked */
.custom-radio .radio-dot::after {
  content: '';
  position: absolute;
  top: 4px;
  left: 4px;
  width: 8px;
  height: 8px;
  background: #00b4b4;
  border-radius: 50%;
  opacity: 0;
  transform: scale(0);
  transition: all 0.2s ease;
}

.custom-radio input[type="radio"]:checked + .radio-dot::after {
  opacity: 1;
  transform: scale(1);
}

/* Hover effect */
.custom-radio:hover .radio-dot {
  border-color: #00b4b4;
}

/* Focus state for all .form-control elements (inputs, selects, textareas) */
.form-control:focus {
  border-color: #00b4b4 !important;

  outline: none;  /* removes any default browser outline */
}

/* Optional: stronger hover/focus for selects specifically */
select.form-control:focus {
  border-color: #00b4b4 !important;

}

/* Optional: make the border slightly thicker or change on hover too */
.form-control:hover {
  border-color: #009999;  /* darker teal on hover (subtle feedback) */
}
.v-toast__item {
    opacity: 1;
    min-height: 40px!important;
}
.v-toast__text {
    opacity: 1;
    min-height: 40px!important;
}
.v-toast__item .v-toast__text {
    padding: 10px 20px!important;
}
.v-toast__item--error {
    background-color: #b40000;
}
.v-toast__item--success {
    background-color: #00b4b4;
}
.v-toast__item .v-toast__icon {
    display: block;
    width: 20px!important;
    min-width: 20px!important;
    height: 20px!important;
    margin-left: 20px!important;
}

</style>
